let elements = {
  blockCheck: true,
  blockWrongColor: true,
  audio: {
    negative: 'games/page046_game0/audio/false.mp3',
    // positive: 'games/page046_game0/audio/true.mp3',
    click: 'games/page046_game0/audio/click.mp3',
  },
  image: {
    trImage: 'games/page046_game0/img/img_t.webp',
    srcImage: 'games/page046_game0/img/img_o.png',
    srcMask: 'games/page046_game0/img/img_m.png',
    width: 1920,
    height: 1080,
    colors: {
      1: '#000000',
      2: '#4faf48',
      3: '#ffde1a',
      4: '#7d4e9a',
      5: '#e62f26',
    },
    cssStyle: {
      position: 'absolute',
      left: '0px',
      top: '0px',
      height: '1080px',
      width: '1920px',
    },
  },
  palette: {
    colors: [
      {
        val: '#05a6e2', // blue
        audio: 'games/page033_game1/audio/10_blue.mp3',
        waitingToBeClicked: { src: 'games/page033_game1/img/blue.png' },
        clicked: { src: 'games/page033_game1/img/blue_p.png' },
        cssStyle: {
          position: 'absolute',
          left: '25%',
          top: '90.5%',
          width: '4%',
          height: '6.8%',
          transform: 'rotate(0deg)',
          'border-radius': '0%',
          // 'background-color': 'rgba(83,187,63,0.4)',
        },
      },
      {
        val: '#e62f26', // red
        audio: 'games/page046_game0/audio/65_T-shirt.mp3',
        waitingToBeClicked: { src: 'games/page033_game1/img/red.png' },
        clicked: { src: 'games/page033_game1/img/red_p.png' },
        cssStyle: {
          position: 'absolute',
          left: '31.5%',
          top: '90.5%',
          width: '4%',
          height: '6.8%',
          transform: 'rotate(0deg)',
          'border-radius': '0%',
          // 'background-color': 'rgba(83,187,63,0.4)',
        },
      },
      {
        val: '#ffde1a', // yellow
        audio: 'games/page046_game0/audio/64_hat.mp3',
        waitingToBeClicked: { src: 'games/page033_game1/img/yellow.png' },
        clicked: { src: 'games/page033_game1/img/yellow_p.png' },
        cssStyle: {
          position: 'absolute',
          left: '38%',
          top: '90.5%',
          width: '4%',
          height: '6.8%',
          transform: 'rotate(0deg)',
          'border-radius': '0%',
          // 'background-color': 'rgba(83,187,63,0.4)',
        },
      },
      {
        val: '#4faf48', // green
        audio: 'games/page046_game0/audio/67_jumper.mp3',
        waitingToBeClicked: { src: 'games/page033_game1/img/green.png' },
        clicked: { src: 'games/page033_game1/img/green_p.png' },
        cssStyle: {
          position: 'absolute',
          left: '44.5%',
          top: '90.5%',
          width: '4%',
          height: '6.8%',
          transform: 'rotate(0deg)',
          'border-radius': '0%',
          // 'background-color': 'rgba(83,187,63,0.4)',
        },
      },
      {
        val: '#7d4e9a', // purple
        audio: 'games/page046_game0/audio/66_dress.mp3',
        waitingToBeClicked: { src: 'games/page033_game1/img/purple.png' },
        clicked: { src: 'games/page033_game1/img/purple_p.png' },
        cssStyle: {
          position: 'absolute',
          left: '51%',
          top: '90.5%',
          width: '4%',
          height: '6.8%',
          transform: 'rotate(0deg)',
          'border-radius': '0%',
          // 'background-color': 'rgba(83,187,63,0.4)',
        },
      },
      {
        val: '#ff69c0', // pink
        audio: 'games/page033_game1/audio/13_pink.mp3',
        waitingToBeClicked: { src: 'games/page033_game1/img/pink.png' },
        clicked: { src: 'games/page033_game1/img/pink_p.png' },
        cssStyle: {
          position: 'absolute',
          left: '57.5%',
          top: '90.5%',
          width: '4%',
          height: '6.8%',
          transform: 'rotate(0deg)',
          'border-radius': '0%',
          // 'background-color': 'rgba(83,187,63,0.4)',
        },
      },
      {
        val: '#f47430', // orange
        audio: 'games/page033_game1/audio/14_orange.mp3',
        waitingToBeClicked: { src: 'games/page033_game1/img/orange.png' },
        clicked: { src: 'games/page033_game1/img/orange_p.png' },
        cssStyle: {
          position: 'absolute',
          left: '64%',
          top: '90.5%',
          width: '4%',
          height: '6.8%',
          transform: 'rotate(0deg)',
          'border-radius': '0%',
          // 'background-color': 'rgba(83,187,63,0.4)',
        },
      },
    ],
  },
  //   colors: [
  //     {
  //       val: '#e62f26',
  //       audio: 'games/page046_game0/audio/65_T-shirt.mp3',
  //       cssStyle: {
  //         position: 'absolute',
  //         left: '0.5%',
  //         top: '70%',
  //         width: '2.2%',
  //         height: '4%',
  //         transform: 'rotate(0deg)',
  //         'border-radius': '50%',
  //         'background-color': 'rgba(230,47,38,1)',
  //       },
  //     },
  //     {
  //       val: '#ff00ff',
  //       // audio: 'games/page046_game0/audio/53_fish.mp3',
  //       cssStyle: {
  //         position: 'absolute',
  //         left: '0.5%',
  //         top: '74.25%',
  //         width: '2.2%',
  //         height: '4%',
  //         transform: 'rotate(0deg)',
  //         'border-radius': '50%',
  //         'background-color': 'rgba(255,0,255,1)',
  //       },
  //     },
  //     {
  //       val: '#4faf48',
  //       audio: 'games/page046_game0/audio/67_jumper.mp3',
  //       cssStyle: {
  //         position: 'absolute',
  //         left: '0.5%',
  //         top: '78.5%',
  //         width: '2.2%',
  //         height: '4%',
  //         transform: 'rotate(0deg)',
  //         'border-radius': '50%',
  //         'background-color': 'rgba(79,175,72,1)',
  //       },
  //     },
  //     {
  //       val: '#0000ff',
  //       // audio: 'games/page046_game0/audio/50_dog.mp3',
  //       cssStyle: {
  //         position: 'absolute',
  //         left: '0.5%',
  //         top: '82.75%',
  //         width: '2.2%',
  //         height: '4%',
  //         transform: 'rotate(0deg)',
  //         'border-radius': '50%',
  //         'background-color': 'rgba(0,0,255,1)',
  //       },
  //     },
  //     {
  //       val: '#ff8000',
  //       // audio: 'games/page046_game0/audio/51_cat.mp3',
  //       cssStyle: {
  //         position: 'absolute',
  //         left: '0.5%',
  //         top: '87%',
  //         width: '2.2%',
  //         height: '4%',
  //         transform: 'rotate(0deg)',
  //         'border-radius': '50%',
  //         'background-color': 'rgba(255,128,0,1)',
  //       },
  //     },
  //     {
  //       val: '#ffde1a',
  //       audio: 'games/page046_game0/audio/64_hat.mp3',
  //       cssStyle: {
  //         position: 'absolute',
  //         left: '0.5%',
  //         top: '91.25%',
  //         width: '2.2%',
  //         height: '4%',
  //         transform: 'rotate(0deg)',
  //         'border-radius': '50%',
  //         'background-color': 'rgba(255,222,26,1)',
  //       },
  //     },
  //     {
  //       val: '#7d4e9a',
  //       audio: 'games/page046_game0/audio/66_dress.mp3',
  //       cssStyle: {
  //         position: 'absolute',
  //         left: '0.5%',
  //         top: '95.5%',
  //         width: '2.2%',
  //         height: '4%',
  //         transform: 'rotate(0deg)',
  //         'border-radius': '50%',
  //         'background-color': 'rgba(125,78,154,1)',
  //       },
  //     },
  //   ],
  mbStaticAudioItemData: [
    {
      src: 'games/page046_game0/audio/64_hat.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page046_game0/img/audioOn.png', iconOff: 'games/page046_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 440,
        x: 1730,
      },
      width: '46px',
      height: '46px',
      unit: 'px',
    },
    {
      src: 'games/page046_game0/audio/65_T-shirt.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page046_game0/img/audioOn.png', iconOff: 'games/page046_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 665,
        x: 1730,
      },
      width: '46px',
      height: '46px',
      unit: 'px',
    },
    {
      src: 'games/page046_game0/audio/66_dress.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page046_game0/img/audioOn.png', iconOff: 'games/page046_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 760,
        x: 1410,
      },
      width: '46px',
      height: '46px',
      unit: 'px',
    },
    {
      src: 'games/page046_game0/audio/67_jumper.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page046_game0/img/audioOn.png', iconOff: 'games/page046_game0/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 160,
        x: 1630,
      },
      width: '46px',
      height: '46px',
      unit: 'px',
    },
  ],
};

export default elements;
